import { useMemo } from 'react';
import { useGetCampaignSourcesQuery } from '@api/apiCompat';

export const useCampaignSources = (id: string) => {
  const { data, isLoading, error } = useGetCampaignSourcesQuery(
    { campaignTypeId: Number(id) || 0 } as any,
    {
      refetchOnMountOrArgChange: true,
      skip: id === null || id === 'undefined',
    },
  );
  const info = useMemo(() => data ?? [], [data]);
  return { data: info, isLoading, error };
};
